import {
  API_GET_JIT_FILTERS,
  API_GET_STOCK_JIT_BY_PROVIDER,
  API_DOWNLOAD_JIT_COVERAGE_PARTS,
  API_PUT_COMMENT,
  API_GET_TRANSIT_BY_PIECE,
  API_DELETE_TRANSIT_BY_ID,
  API_EDIT_TRANSITS,
  API_REMARKS,
  API_TRANSITS,
  API_GET_JIT_PR_FILTER,
  API_M100,
  API_STOCK_STTATUS
} from './urls';
import IApi from 'modules/shared/domain/IApi';
import api from 'modules/shared/infrastructure/api/Api';
import PartCoverageDTO from '../dto/PartCoverageDTO';
import BaseRepository from 'modules/shared/infrastructure/repositories/BaseRepository';
import IJitRepository from '../../domain/IJitRepository';
import JitFiltersDataDTO from '../dto/PartCoverageFiltersDTO';
import TransitDataDTO, { LoadDTO } from '../dto/TransitsDTO';
import { CreateRemarkDTO, RemarksDTO, RemarksListDTO } from '../dto/RemarksDTO';
import { RemarkDataDTO } from '../dto/RemarkDTO';
import { RemarkMapper } from '../mappers/remark.mapper';
import { LoadDataToBack } from '../mappers/load.mapper';

class JitRepository extends BaseRepository implements IJitRepository {
  private readonly _api: IApi;
  private readonly _apiGetJitStockByProvider: (providerName: string) => string;
  private readonly _apiGetJitFilters: string;
  private readonly _apiGetJitPRFilter: string;
  private readonly _apiGetDownloadJitStock: (username: string) => string;
  private readonly _apiPutComment: (code: string) => string;
  private readonly _apiGetTransitsByPiece: string;
  private readonly _apiDeleteTransitsById: string;
  private readonly _apiEditTransits: string;
  private readonly _apiRemarks: string;
  private readonly _apiTransits: string;
  private readonly _apiM100: string;
  private readonly _apiStockStatus: string;

  constructor({
    api,
    apiGetJitStockByProvider,
    apiGetJitFilters,
    apiGetJitPRFilter,
    apiGetDownloadJitStock,
    apiPutComment,
    apiGetTransitsByPiece,
    apiDeleteTransitsById,
    apiEditTransits,
    apiRemarks,
    apiTransits,
    apiM100,
    apiStockStatus
  }) {
    super();
    this._api = api;
    this._apiGetJitStockByProvider = apiGetJitStockByProvider;
    this._apiGetJitFilters = apiGetJitFilters;
    this._apiGetJitPRFilter = apiGetJitPRFilter;
    this._apiGetDownloadJitStock = apiGetDownloadJitStock;
    this._apiPutComment = apiPutComment;
    this._apiGetTransitsByPiece = apiGetTransitsByPiece;
    this._apiDeleteTransitsById = apiDeleteTransitsById;
    this._apiEditTransits = apiEditTransits;
    this._apiRemarks = apiRemarks;
    this._apiTransits = apiTransits;
    this._apiM100 = apiM100;
    this._apiStockStatus = apiStockStatus;
  }

  get({ queryParams, username }: { queryParams: object; username: string }) {
    const url = `${this._apiGetJitStockByProvider(
      username
    )}${this._createQueryParams(queryParams)}`;
    return this._api.get(url).then((res) => new PartCoverageDTO(res));
  }

  getPartCoverageFilters({ queryParams }: { queryParams: object }) {
    const url = `${this._apiGetJitFilters}${this._createQueryParams(
      queryParams
    )}`;

    return this._api.get(url).then((res) => new JitFiltersDataDTO(res));
  }

  getPartCoveragePRFilter(query: string) {
    const url = `${this._apiGetJitPRFilter}/${query}`;
    return this._api.get(url);
  }

  downloadJitStock({
    queryParams,
    username
  }: {
    queryParams: object;
    username: string;
  }) {
    const url = `${this._apiGetDownloadJitStock(
      username
    )}${this._createQueryParams(queryParams)}`;
    const headers = {
      Accept:
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    };
    return this._api.getBlob({ url, headers });
  }

  updateComment({ code, body }: { code: string; body: { text: string } }) {
    return this._api
      .put(`${this._apiPutComment(code)}`, body)
      .then((res) => res);
  }
  //Transits
  getJitLoadsByPiece({ queryParams }: { queryParams: object }) {
    const url = `${this._apiGetTransitsByPiece}${this._createQueryParams(
      queryParams
    )}`;
    return this._api.get(url).then((res) => {
      return new TransitDataDTO(res[0]);
    });
  }

  deleteJitTransitsById({
    queryParams
  }: {
    queryParams: { code: string; delivery_date: string };
  }) {
    const url = `${this._apiDeleteTransitsById}/${queryParams.code}/${queryParams.delivery_date}`;
    return this._api.delete(url).then((res) => res);
  }
  editJitTransits({ body }: { body: LoadDTO }) {
    return this._api
      .put(`${this._apiEditTransits}`, { loads: [body] })
      .then((res) => res);
  }
  createJitTransit({ body }: { body: LoadDataToBack }) {
    return this._api
      .postErrorManagement(`${this._apiTransits}`, body)
      .then((res) => res);
  }
  //Remarcks
  async getJitRemarksByPiece({
    queryParams
  }: {
    queryParams: {
      code: string;
      provider_id: number;
      provider_tier: string;
      fromDate: string;
    };
  }) {
    const url = `${this._apiRemarks}/${queryParams.code}/${queryParams.provider_id}/${queryParams.provider_tier}/${queryParams.fromDate}`;
    const response = await this._api.get(url).then((res) => {
      return new RemarksListDTO(res);
    });
    return RemarkMapper.toDomainList(response.data);
  }
  getJitRemarksById({ queryParams }: { queryParams: { id: number } }) {
    const url = `${this._apiRemarks}/${queryParams.id}`;
    return this._api.get(url).then((res) => {
      return new RemarkDataDTO(res);
    });
  }
  createJitRemark({ body }: { body: CreateRemarkDTO }) {
    return this._api.post(`${this._apiRemarks}`, body).then((res) => res);
  }
  editJitRemark({ body }: { body: RemarksDTO }) {
    return this._api.put(`${this._apiRemarks}`, body).then((res) => res);
  }
  deleteJitRemarksById({ queryParams }: { queryParams: { id: number } }) {
    const url = `${this._apiRemarks}/${queryParams.id}`;
    return this._api.delete(url).then((res) => res);
  }
  downloadJitRemark({ queryParams }: { queryParams: { id: number } }) {
    const url = `${this._apiRemarks}/download/${queryParams.id}`;
    const headers = {
      Accept:
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    };
    const typeMIME = 'application/pdf';
    return this._api.getBlobBase64({ url, headers, typeMIME });
  }
  downloadM100({
    queryParams
  }: {
    queryParams: { code: string; providerId: number; providerTier: string };
  }) {
    //@router.get("/program-coverage/m100/download/<code>/<provider_id>/<provider_tier>")
    //https://cdsc-inbound-api.pre.code.seat.cloud.vwgroup.com/program-coverage/M100/download/W0022971842/41508/JIT-TIER1

    const url = `${this._apiM100}/download/${queryParams.code}/${queryParams.providerId}/${queryParams.providerTier}`;
    const headers = {
      Accept:
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    };
    const typeMIME =
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
    return this._api.getBlobBase64({ url, headers, typeMIME });
  }
  getStockStatus({
    queryParams
  }: {
    queryParams: { code: string; providerId: number; providerTier: string };
  }) {
    //@router.get("/program-coverage/stock-status/<code>/<provider_id>/<provider_tier>")

    const url = `${this._apiStockStatus}/${queryParams.code}/${queryParams.providerId}/${queryParams.providerTier}`;
    return this._api.get(url);
  }
}

export default new JitRepository({
  api: api,
  apiGetJitStockByProvider: API_GET_STOCK_JIT_BY_PROVIDER,
  apiGetJitFilters: API_GET_JIT_FILTERS,
  apiGetJitPRFilter: API_GET_JIT_PR_FILTER,
  apiGetDownloadJitStock: API_DOWNLOAD_JIT_COVERAGE_PARTS,
  apiPutComment: API_PUT_COMMENT,
  apiGetTransitsByPiece: API_GET_TRANSIT_BY_PIECE,
  apiDeleteTransitsById: API_DELETE_TRANSIT_BY_ID,
  apiEditTransits: API_EDIT_TRANSITS,
  apiRemarks: API_REMARKS,
  apiTransits: API_TRANSITS,
  apiM100: API_M100,
  apiStockStatus: API_STOCK_STTATUS
});

export { JitRepository };
